module.exports = __webpack_public_path__ + "static/media/icon-compost.abb07535.svg";